import React, { use,useState } from "react";
import { Link, NavLink } from "react-router-dom"; // Changed from Link to NavLink
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const NavBarMain = () => {
  const cookie1 = Cookies.get("mycookie1");
  const cookie2 = Cookies.get("mycookie2");
  const cookie3 = Cookies.get("mycookie3");
  const myrole = Cookies.get("mycookie4");
  const [loggedIn, SetLoggedIn] = useState(1);
  const navigate = useNavigate();
  
  return (
    <div>
                  {/* { <NavLink to="/"><span>*{loggedIn}*</span></NavLink>} */}

        <div className="navbar fixed shadow-sm bg-gray-300 text-cyan-950 font-bold z-50">
          <div className="navbar-start">
            <div className="dropdown">
              <div tabIndex={0} role="button" className="btn btn-ghost lg:hidden">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {" "}
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h8m-8 6h16"
                  />{" "}
                </svg>
              </div>
              <ul
                tabIndex={0}
                className="menu menu-sm dropdown-content bg-base-100 rounded-box z-1 mt-3 w-52 p-2 shadow"
              >
                {/* <li>
                  <NavLink 
                    to="/rootpage" 
                    className={({ isActive }) => 
                      isActive ? 'text-red-500 font-bold' : ''
                    }
                  >
                    HOME
                  </NavLink>
                </li> */}
                {/* <li>
                  <NavLink 
                    to="/tutor"
                    className={({ isActive }) => 
                      isActive ? 'text-red-500 font-bold' : ''
                    }
                  >
                    TUTOR
                  </NavLink>
                </li> */}
                {/* <li>
                  <NavLink 
                    to="/student"
                    className={({ isActive }) => 
                      isActive ? 'text-red-500 font-bold' : ''
                    }
                  >
                    STUDENT
                  </NavLink>
                </li> */}
                {/* <li>
                  <NavLink 
                    to="/administrator"
                    className={({ isActive }) => 
                      isActive ? 'text-red-500 font-bold' : ''
                    }
                  >
                    ADMINISTRATOR
                  </NavLink>
                </li> */}
              </ul>
            </div>
            <NavLink to="/" className="btn btn-ghost p-0">
              <img
                className="w-auto h-14"
                src="images-pub/nova-logo.png"
                alt="Logo"
              />
            </NavLink>
          </div>
          <div className="navbar-center hidden lg:flex">
            <ul className="menu menu-horizontal px-1">
              {/* <li>
                <NavLink 
                  to="/rootpage"
                  className={({ isActive }) => 
                    isActive ? 'text-red-500 font-bold' : ''
                  }
                >
                  HOME
                </NavLink>
              </li> */}
              {/* <li>
                <NavLink 
                  to="/tutor"
                  className={({ isActive }) => 
                    isActive ? 'text-red-500 font-bold' : ''
                  }
                >
                  TUTOR
                </NavLink>
              </li> */}
              {/* <li>
                <NavLink 
                  to="/student"
                  className={({ isActive }) => 
                    isActive ? 'text-red-500 font-bold' : ''
                  }
                >
                  STUDENT
                </NavLink>
              </li> */}
              {/* <li>
                <NavLink 
                  to="/administrator"
                  className={({ isActive }) => 
                    isActive ? 'text-red-500 font-bold' : ''
                  }
                >
                  ADMINISTRATOR
                </NavLink>
              </li> */}
              {/* <li>
                <NavLink 
                  to="/model"
                  className={({ isActive }) => 
                    isActive ? 'text-red-500 font-bold' : ''
                  }
                >
                  MODEL UPLOAD
                </NavLink>
              </li> */}
            </ul>
          </div>

          <span className="font-bold m-auto bg-red color-primary">{cookie1}</span>
          {cookie1 && (
          <button 
            className="btn btn-outline btn-primary absolute top-4 right-4"
            onClick={() => {
              Cookies.remove("mycookie1");
              Cookies.remove("mycookie2");
              Cookies.remove("mycookie3");
              Cookies.remove("mycookie4");
              // SetLoggedIn(0);
              navigate('/');
            }}
          >
            Logout
          </button>
                     )}



                      {(cookie1 && myrole=='admin') && (
          <button 
            className="btn btn-primary absolute top-20 right-4"
            onClick={() => {
              
              navigate('/simpletabs');
            }}
          >
            Dashboard
          </button>
                     )}

        </div>
       
    </div>
  );
};

export default NavBarMain;